import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import { useSignOutConfirmation } from '@/auth/useSignOutConfirmation'
import { BrandMark } from './BrandMark'

/** Width of the centered onboarding column (Google-Form-like). */
export const ONBOARDING_MAX_WIDTH = 720

/**
 * Centered, chrome-free layout for the post-sign-up onboarding step.
 *
 * Unlike {@link AppShell}, this has no navigation drawer: the applicant is not
 * an approved member yet, so they only get a slim header (brand + sign out) and
 * a centered column — mirroring a Google Form's focused viewport.
 */
export function OnboardingLayout() {
  const { requestSignOut, dialog } = useSignOutConfirmation()

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider' }}>
        <Box
          sx={{
            maxWidth: ONBOARDING_MAX_WIDTH,
            mx: 'auto',
            px: { xs: 2, sm: 3 },
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <BrandMark />
          <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', minWidth: 0 }}>
            <Button
              size="small"
              color="inherit"
              startIcon={<LogoutOutlinedIcon fontSize="small" />}
              onClick={requestSignOut}
            >
              Sign out
            </Button>
          </Stack>
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            maxWidth: ONBOARDING_MAX_WIDTH,
            mx: 'auto',
            px: { xs: 2, sm: 3 },
            py: { xs: 3, sm: 5 },
          }}
        >
          <Outlet />
        </Box>
      </Box>

      <Divider />
      <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
        DOLE AIMS · Audit Information Management System
      </Typography>
      {dialog}
    </Box>
  )
}
